import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { CoreLink } from '../../../../../components';
import useClasses from '../../../../../hooks/useClasses';

const MenuMainSubmenuItem = ({ entity, onNavigate }) => {
  const { t } = useTranslation();
  const href = entity.getIn(['link', 'url'], '');
  const title = entity.getIn(['link', 'title'], '');
  const target = entity.getIn(['link', 'options', 'attributes', 'target'], '');
  const className = entity.getIn(['link', 'options', 'attributes', 'class', 0], '');
  const titleIsLogout = title.includes(t('buttons.logout'));
  const targetIsBlank = target === '_blank';

  // @TODO: Come up with a better way of doing this.
  const isSupportItem = className.includes('support');

  const { buildClass, joinClasses } = useClasses('MenuMainItem', 'submenu', {
    'target--blank': targetIsBlank,
  });

  const iconClasses = c(
    'icon',
    className,
    {
      'icon-exit': titleIsLogout,
    },
  );

  const Wrapper = isSupportItem ?
    (wrapperProps) => <button {...wrapperProps} type="button" /> :
    (wrapperProps) => <CoreLink {...wrapperProps} to={href} />;

  return (
    <li key={href}>
      <Wrapper
        className={joinClasses(buildClass(), 'menu-item')}
        onClick={() => onNavigate(isSupportItem)}
      >
        {className || titleIsLogout ? (
          <div className={joinClasses(buildClass('icon'), iconClasses)} />
        ) : (
          <div className={buildClass('icon-spacer')} />
        )}
        {title}
      </Wrapper>
    </li>
  );
};

export default MenuMainSubmenuItem;
